import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgThumbsUp = (props: SvgProps) => (
  <Svg fill="none" height={35} width={34} {...props}>
    <Path
      fill="#fff"
      d="M18.363 1.282a1.616 1.616 0 0 1 1.671-.799l.513.086a7 7 0 0 1 5.58 8.827l-.986 3.45h1.432a7 7 0 0 1 6.716 8.975l-2.445 8.312a5.924 5.924 0 0 1-5.684 4.252H14.57a8.078 8.078 0 0 1-4.704-1.512 3.77 3.77 0 0 1-3.02 1.512H4.154a3.77 3.77 0 0 1-3.77-3.77v-14a3.77 3.77 0 0 1 3.77-3.769h7.36a.539.539 0 0 0 .467-.273l6.382-11.29Zm-7.747 28.039.853.71a4.842 4.842 0 0 0 3.101 1.123h10.59a2.692 2.692 0 0 0 2.585-1.932l2.445-8.312a3.77 3.77 0 0 0-3.617-4.833H23a1.616 1.616 0 0 1-1.553-2.06l1.575-5.509A3.77 3.77 0 0 0 20.594 3.9l-5.8 10.263a3.769 3.769 0 0 1-3.28 1.915h-.898V29.32ZM7.385 16.077H4.154a.538.538 0 0 0-.538.538v14c0 .298.24.539.538.539h2.692a.538.538 0 0 0 .539-.539V16.077Z"
    />
  </Svg>
);
const Memo = memo(SvgThumbsUp);
export default Memo;
